export default __webpack_public_path__ + "static/Monda-Regular-e92622470a303406a62af630524da70b.ttf";